import React from "react";
import { Box, Typography } from "@mui/material";

const noRoleAnimations = `
  @keyframes shield-float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-10px) rotate(2deg); }
  }
  @keyframes line-reveal {
    0% { width: 0; opacity: 0; }
    100% { width: 40px; opacity: 1; }
  }
  @keyframes pulse-warn {
    0%, 100% { opacity: 0.1; transform: scale(1); }
    50% { opacity: 0.2; transform: scale(1.1); }
  }
`;

const NoRolesFound = () => {
  return (
    <Box
      sx={{
        height: "80vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F8FAFC",
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
        border: "1px solid #E2E8F0",
      }}
    >
      <style>{noRoleAnimations}</style>

      {/* Animated Shield SVG Icon */}
      <Box
        sx={{
          position: "relative",
          mb: 3,
          animation: "shield-float 5s ease-in-out infinite",
        }}
      >
        <svg
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#94A3B8"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Shield Outline */}
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />

          {/* Empty Center / Lock Hole */}
          <circle
            cx="12"
            cy="11"
            r="3"
            stroke="#2563EB"
            strokeWidth="1.5"
            strokeDasharray="2 2"
          />
          <path d="M12 14v3" stroke="#2563EB" strokeWidth="2" />
        </svg>

        {/* Subtle Background Warning Glow */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 110,
            height: 110,
            bgcolor: "rgba(37, 99, 235, 0.15)",
            borderRadius: "40%",
            transform: "translate(-50%, -50%)",
            zIndex: -1,
            animation: "pulse-warn 3s ease-in-out infinite",
          }}
        />
      </Box>

      {/* Text Content */}
      <Box sx={{ textAlign: "center", zIndex: 1 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 900,
            color: "#0F172A",
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          No Roles Assigned
        </Typography>

        <Box
          sx={{
            height: "2px",
            width: "40px",
            bgcolor: "#2563EB",
            margin: "0 auto 16px",
            animation: "line-reveal 1s ease-out forwards",
          }}
        />

        <Typography
          sx={{
            fontSize: "11px",
            color: "#64748B",
            fontWeight: 700,
            maxWidth: "280px",
            lineHeight: 1.6,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          Access Control List is empty. No security roles or permissions were
          detected for this entity.
        </Typography>
      </Box>

      {/* Technical Metadata Footer */}
      <Box
        sx={{
          position: "absolute",
          top: 30,
          left: 30,
          opacity: 0.3,
          fontFamily: "monospace",
          fontSize: "9px",
          color: "#475569",
          lineHeight: 2,
        }}
      >
        POLICY_STATUS: UNSET
        <br />
        ACL_INDEX: 0x0000
        <br />
        SCOPE: RBAC_NULL
      </Box>
    </Box>
  );
};

export default NoRolesFound;
